'use client';
import { type AgeGroups, LargeCheckboxInput } from '@baseball-near-you/ui';
import { useFormContext } from 'react-hook-form';

export function AgeGroupCheckbox(props: {
  ageGroup: (typeof AgeGroups)[number];
}) {
  const { watch, setValue } = useFormContext();
  const ageGroups: (typeof AgeGroups)[number][] = watch('ageGroups');

  return (
    <LargeCheckboxInput
      label={props.ageGroup === '18+' ? '18+' : `${props.ageGroup}U`}
      onChange={(e) => {
        if (e.target.checked) {
          setValue('ageGroups', [...ageGroups, props.ageGroup]);
        } else {
          setValue(
            'ageGroups',
            ageGroups.filter((a) => a !== props.ageGroup)
          );
        }
      }}
      checked={ageGroups.includes(props.ageGroup)}
    />
  );
}
